import { useMutation, UseMutationResult, useQuery } from 'react-query';
import { createManualCompany, getLinkedInCompaniesList } from '../api/talentsApi';
import { GET_COMPANIES_FROM } from '../consts';
import { getServerError, isLinkedinUrl } from '../utils';

export const useGetCompaniesQuery = (
  query: string,
  setTypeCallback?: (type:string) => void,
): CompaniesResponse => {
  const {
    isLoading,
    data,
  } = useQuery<CompaniesResponse>(['getCompanies', query],
    async () => {
      if (query.length !== 0) {
        if (isLinkedinUrl(query)) {
          if (setTypeCallback) {
            setTypeCallback(GET_COMPANIES_FROM.LINKEDIN);
          }

          return getLinkedInCompaniesList(query);
        }
        // TODO rollback
        // if (setTypeCallback) {
        //   setTypeCallback(GET_COMPANIES_FROM.DB);
        // }
        
        // const companiesResponse = await getCompaniesList(query);
        
        // return companiesResponse.results;

        if (setTypeCallback) {
          setTypeCallback(GET_COMPANIES_FROM.DB);
        }

        return [];
      }

      return null;
    }, {
      retry: false,
    });

  return {
    companies: data || [],
    isLoading,
  };
};

type Error = {
  hasError:boolean,
  errorMessage: string,
}

export const useCreateNewManualCompany = (
  onSuccessCallback: (companyId: string) => void,
  onErrorCallback: (object: Error)=> void,
): UseMutationResult<Company, ServerError, CreateManualCompanyRequest, unknown> => {
  return useMutation((query:CreateManualCompanyRequest) => {
    return createManualCompany(query);
  }, {
    onSuccess: (response: Company) => {
      onSuccessCallback(response?.id || '');
    },
    onError: (error:ServerError) => {
      const errorMessage = getServerError(error);
      onErrorCallback({
        hasError: true,
        errorMessage,
      },
      );
    },
  });
};
